import { Button, InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import FormFactory from "../../../../components/FormFactory";
import withRouter from "../../../../withRouter";
import UsersFormPresenter from "./UsersFormPresenter";
import InputFactory from "../../../../components/InputFactory";

class UsersFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, progress: false };
    this.presenter = new UsersFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const { object } = this.state;
  //   if (prevState.object.employee !== object) {
  //     this.setState({object.})
  //     console.log("OJBECT: ", object);
  //   }
  // }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }
  getCollectionName() {
    return "users";
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const progress = this.state.progress;
    let schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";

    const excludeFields = ["fingerPrint", "fingerFid", "fingerSize"];

    if (this.getObjectId() !== undefined) {
      excludeFields.push("password");
    }

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {object?.employee?.biometricId && (
                          <div className="col-md-12">
                            <label className="form-label fs-sm">
                              Biometric ID
                            </label>
                            <InputFactory
                              type="String"
                              value={object?.employee?.biometricId}
                              disabled
                              className="form-control"
                              required
                            />
                          </div>
                        )}

                        <FormFactory
                          schema={schema}
                          object={object}
                          onChange={this.onChange.bind(this)}
                          excludeFields={excludeFields}
                          pick={this.getCollectionName()}
                          disabledAddMore={true}
                        />
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <Button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                      progress={progress}
                      disabled={progress}
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-light fs-sm"
                      progress={progress}
                      disabled={progress}
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(UsersFormPage);
